/* eslint-disable no-unused-vars */

import React, { useEffect, useState } from 'react';

import useAPIHandler from '../../../hook/use-api-handler';
import useSnackbar from '../../../hook/use-snakbar';
import { getInputFieldProps } from '../../../utils/common';
import fetchDataWithPromise from '../../../utils/fetch-data';
import { logger, safeString } from '../../../utils/logger';
import { BANKING_API, BANKING_INITIAL_STATE, BANK_INPUT_FIELDS } from './banking-constant';
import { bankingFormSchema } from './banking-validation';

const useBankingService = () => {
  const [isPrimaryBankError, setIsPrimaryBankError] = useState(false)
  const [open, setOpen] = React.useState(false);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [resource, setResource] = useState(null);
  const {
    snackbarVisible,
    snackbarMessage,
    openSnackbar,
    closeSnackbar,
    snackColor,
  } = useSnackbar();
  const handleClickOpen = () => {
    setOrganisationBanking(structuredClone(BANKING_INITIAL_STATE));
    setErrors({});
    setOpen(true)
  };
  const handleClose = () => setOpen(false);

  const [organisationBanking, setOrganisationBanking] = useState(
    structuredClone(BANKING_INITIAL_STATE)
  );
  const { fetchData } = useAPIHandler();
  const [createUpdateLoading, setCreateUpdateLoading] = useState(false);

  const [errors, setErrors] = useState({});



  const handleChangeFunction = (e, name) => {

    let value = e;

    if (e && e.target) {
      value = e.target.value;
    }

    if (
      BANK_INPUT_FIELDS[name].customOptions &&
      BANK_INPUT_FIELDS[name].customOptions?.formatValueFn
    ) {
      value = BANK_INPUT_FIELDS[name].customOptions?.formatValueFn(
        value,
        organisationBanking
      );
    }

    setOrganisationBanking((prevUser) => ({
      ...prevUser,
      [name]: value,
    }));

    const fieldSchema = bankingFormSchema.extract(name);
    const { error } = fieldSchema.validate(value, {
      //   context: { allowanceType: allowance.allowanceType },
    });

    if (!error) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: undefined,
      }));
    }
  };




  const handleSubmitFn = async () => {
    let payloadInfo = {};


    if (!organisationBanking?.org_bank_id) {
      payloadInfo = { ...BANKING_API.BANKING_CREATE }
    } else {
      payloadInfo = {
        url: BANKING_API.BANKING_UPDATE.url + organisationBanking?.org_bank_id,
        method: BANKING_API.BANKING_UPDATE.method,
      }

    }
    const {
      bank_name,
      branch_name,
      account_no,
      ifsc_no,
      account_type,
      is_primary, 
      org_bank_id,
      is_force_primary,
    } = organisationBanking;

    let validationErrors = {};

    if (org_bank_id) {
      const existingAccounts = resource.read()?.data?.data?.data?.filter(it => it?.org_bank_id !== org_bank_id).map(item => item.account_no)
      if (account_no) {
        const duplicateAcc = existingAccounts?.find(existingAccount => existingAccount === account_no);
        if (duplicateAcc) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            account_no: "This account number already exists.",
          }));
          return;
        }

      }
    } else {
      const existingAccounts = resource.read()?.data?.data?.data?.map(item => item.account_no)
      if (account_no) {
        const duplicateAcc = existingAccounts?.find(existingAccount => existingAccount === account_no);
        if (duplicateAcc) {
          // setErrors((prevErrors) => ({
          //   ...prevErrors,
          //   account_no: "This account number already exists.",
          // }));
          // return;
          validationErrors.account_no = "This account number already exists.";
        }

      }
    }

    const { error } = bankingFormSchema.validate({
      bank_name,
      branch_name,
      account_no,
      ifsc_no,
      account_type,
      is_primary,
      is_force_primary,
    }, {
      abortEarly: false,
    });
    // if (error && error?.details?.length > 0) {
    //   const validationErrors = error.details.reduce((acc, err) => {
    //     const pathname = err.path.join(".");
    //     acc[pathname] = err.message;
    //     return acc;
    //   }, {});
    //   setErrors(validationErrors);
    // }
    if (error && error?.details?.length > 0) {
      const schemaErrors = error.details.reduce((acc, err) => {
        const pathname = err.path.join(".");
        acc[pathname] = err.message;
        return acc;
      }, {});
      validationErrors = { ...validationErrors, ...schemaErrors };
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    else {
      const payload = {
        ...payloadInfo,
        data: {
          bank_name,
          branch_name,
          account_no,
          ifsc_no,
          account_type,
          is_primary,
          is_force_primary,
        }
      }

      setCreateUpdateLoading(true);
      try {
        await fetchData(payload);
        openSnackbar({
          message: organisationBanking?.org_bank_id ? "Bank Updated succesfully!" : "Bank Created succesfully!",
          color: "success",
        });
        handleClose();
        setResource(fetchDataWithPromise(BANKING_API.BANKING_LIST.url));
        setIsPrimaryBankError(false);
      } catch (error) {
        if (error?.type === "GeneralError" && error?.message === "You have already primary bank!") {
          setIsPrimaryBankError(true);
        }
        const errorsAll = {};
        let message = "Something went wrong!";



        if (error?.type === "JoiValidationError") {
          error?.errors?.map((curr) => {
            const { field, message } = curr;

            errorsAll[field] = message;


          });

          if (Object.keys(errorsAll).length > 0) {

            message = "Validation Error!";
          }
        }

        if (typeof error?.message === 'string') {
          message = error?.message;
        }

        openSnackbar({
          message,
          color: "danger",
        });
        setErrors(errorsAll)
        setCreateUpdateLoading(false);
      } finally {
        setCreateUpdateLoading(false);
      }
    }
  };


  function handleResetForm(data) {
    setOrganisationBanking({ ...structuredClone(BANKING_INITIAL_STATE), ...data });
    setErrors({})
  }

  function handleBlurFn(e, name) {
    let value = e;

    if (e && e.target) {
      value = e.target.value;
    }

    const fieldSchema = bankingFormSchema.extract(name);
    const { error } = fieldSchema.validate(value);

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error ? error.details[0].message : undefined,
    }));
  }


  const getInputFieldPropsFn = (fieldName = "") => {
    // eslint-disable-next-line no-unused-vars
    const { customOptions = {}, ...restProps } =
      BANK_INPUT_FIELDS[fieldName] || {};





    const error = safeString(errors[fieldName]);
    const props = {
      ...restProps,
      ...getInputFieldProps({
        name: fieldName,
        stateValues: organisationBanking,
        type: restProps.type || "text",
        error,
        handleChangeFunction, handleBlurFn
      }),
    };


    return props;
  };



  useEffect(() => {
    // Refetch data whenever `page` or `search` changes
    setResource(fetchDataWithPromise(BANKING_API.BANKING_LIST.url));
  }, [page, search]);



  logger.log(isPrimaryBankError, "isPrimaryBankError")
  return {
    handleSubmitFn,
    getInputFieldPropsFn,
    organisationBanking,
    createUpdateLoading,
    handleClickOpen,
    handleClose,
    open,
    setOpen,
    handleResetForm,
    snackbarVisible,
    snackbarMessage,
    closeSnackbar,
    snackColor,
    resource,
    isPrimaryBankError
  }
}

export default useBankingService